import { render, staticRenderFns } from "./QCMAnswer.vue?vue&type=template&id=79fa1ba0&"
import script from "./QCMAnswer.vue?vue&type=script&lang=ts&"
export * from "./QCMAnswer.vue?vue&type=script&lang=ts&"
import style0 from "./QCMAnswer.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports